import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from '../components/admin/AdminLayout';
import AdminProtectedRoute from '../components/admin/AdminProtectedRoute';
import SEOHead from '../components/common/SEOHead';
import Layout from '../components/layout/Layout';
import About from '../pages/About';
import AboutCEO from '../pages/AboutCEO';
import AdminApplications from '../pages/AdminApplications';
import AdminApplyTask from '../pages/AdminApplyTask';
import AdminContact from '../pages/AdminContact';
import AdminApplyCms from '../pages/AdminApplyCms';
import AdminBackups from '../pages/AdminBackups';
import AdminDashboard from '../pages/AdminDashboard';
import AdminEmails from '../pages/AdminEmails';
import AdminJobs from '../pages/AdminJobs';
import AdminLogin from '../pages/AdminLogin';
import AdminSeo from '../pages/AdminSeo';
import AdminTaskApplicants from '../pages/AdminTaskApplicants';
import ApplyPage from '../pages/ApplyPage';
import ApplyThankYouPage from '../pages/ApplyThankYouPage';
import CareerPage from '../pages/CareerPage';
import CompleteTaskPage from '../pages/CompleteTaskPage';
import CompleteTaskThankYouPage from '../pages/CompleteTaskThankYouPage';
import Contact from '../pages/Contact';
import HiringProcess from '../pages/HiringProcess';
import Home from '../pages/Home';
import JobDetailPage from '../pages/JobDetailPage';
import JobsPage from '../pages/JobsPage';
import NotFound from '../pages/NotFound';
import ServicePage from '../pages/ServicePage';
import UnsubscribePage from '../pages/UnsubscribePage';
import UpcomingProjects from '../pages/UpcomingProjects';

function AppRoutes() {
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <SEOHead />
      <Routes>
        <Route path="admin/login" element={<AdminLogin />} />
        <Route path="unsubscribe/:token" element={<UnsubscribePage />} />
        <Route
          path="admin"
          element={
            <AdminProtectedRoute>
              <AdminLayout />
            </AdminProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="contact" element={<AdminContact />} />
          <Route path="jobs" element={<AdminJobs />} />
          <Route path="apply-cms" element={<AdminApplyCms />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="apply-task" element={<AdminApplyTask />} />
          <Route path="task-applicants" element={<AdminTaskApplicants />} />
          <Route path="emails" element={<AdminEmails />} />
          <Route path="emails/compose" element={<AdminEmails />} />
          <Route path="emails/:emailId" element={<AdminEmails />} />
          <Route path="backups" element={<AdminBackups />} />
          <Route path="seo" element={<AdminSeo />} />
        </Route>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="services/:serviceSlug" element={<ServicePage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="jobs/:categorySlug/:jobSlug" element={<JobDetailPage />} />
          <Route path="hiring-process" element={<HiringProcess />} />
          <Route path="apply" element={<ApplyPage />} />
          <Route path="apply/thank-you" element={<ApplyThankYouPage />} />
          <Route path="complete-task" element={<CompleteTaskPage />} />
          <Route path="complete-task/thank-you" element={<CompleteTaskThankYouPage />} />
          <Route path="career/:careerSlug" element={<CareerPage />} />
          <Route path="about-ceo" element={<AboutCEO />} />
          <Route path="upcoming-projects" element={<UpcomingProjects />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
